<h2 mat-dialog-title>{{ title() }}</h2>

<mat-dialog-content>
    <mat-vertical-stepper labelPosition="bottom" #stepper>

        <!-- ══ Step 1 – Settings ═════════════════════════════════════════════ -->
        <mat-step [stepControl]="popupFormGroup">
            <form [formGroup]="popupFormGroup">
                <ng-template matStepLabel>Settings</ng-template>

                <div class="row mt-m">
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Typ?</mat-label>
                            <mat-select formControlName="type">
                                <mat-option value="POPUP">Popup</mat-option>
                                <mat-option value="UPDATE">Update</mat-option>
                                <mat-option value="FEEDBACK">Feedback</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Aktiv?</mat-label>
                            <mat-select formControlName="active">
                                <mat-option value="true">Ein</mat-option>
                                <mat-option value="false">Aus</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Public?</mat-label>
                            <mat-select formControlName="public">
                                <mat-option value="true">Ja</mat-option>
                                <mat-option value="false">Nein</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Owner Only?</mat-label>
                            <mat-select formControlName="owner_only">
                                <mat-option value="true">Ja</mat-option>
                                <mat-option value="false">Nein</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Show for Internals?</mat-label>
                            <mat-select formControlName="show_for_internals">
                                <mat-option value="true">Ja</mat-option>
                                <mat-option value="false">Nein</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Subscription?</mat-label>
                            <mat-select formControlName="subscription">
                                <mat-option value="true">Ja</mat-option>
                                <mat-option value="false">Nein</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Condition?</mat-label>
                            <mat-select formControlName="subscription">
                                <mat-option value="IN">IN</mat-option>
                                <mat-option value="NIN">NIN</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Priorität</mat-label>
                            <input matInput autocomplete="off" placeholder="Priorität" formControlName="priority" />
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Page filter</mat-label>
                            <input matInput autocomplete="off" placeholder="Page filter" formControlName="page_filter" />
                        </mat-form-field>
                    </div>

                    <div class="col-md-4">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Zeitraum</mat-label>
                            <mat-date-range-input [rangePicker]="range">
                                <input matStartDate placeholder="Start date" formControlName="start" />
                                <input matEndDate placeholder="End date" formControlName="end" />
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="range" />
                            <mat-date-range-picker #range />
                            <mat-error>Invalid date range</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="text-right">
                    <button class="btn-secondary" matStepperPrevious>Zurück</button>
                    <button class="btn-primary" matStepperNext>Weiter</button>
                </div>
            </form>
        </mat-step>

        <!-- ══ Step 2 – Content ══════════════════════════════════════════════ -->
        <mat-step [stepControl]="popupFormGroup">
            <form [formGroup]="popupFormGroup">
                <ng-template matStepLabel>Content</ng-template>

                <div class="row">
                    <div class="col-md-7">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Dialog titel</mat-label>
                            <input matInput autocomplete="off" placeholder="Titel" formControlName="title" />
                            <mat-error>Titel ist erforderlich</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Link</mat-label>
                            <input matInput autocomplete="off" placeholder="Hyperlink" formControlName="link" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Button</mat-label>
                            <input matInput autocomplete="off" placeholder="Button" formControlName="button" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Text</mat-label>
                            <textarea matInput autocomplete="off" placeholder="Text" formControlName="body"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-md-5">
                        <phx-drag-drop
                                (readFiles)="onImageSelected($event)"
                                (clearFiles)="clearImageSelection()"
                                [acceptedFileTypes]="'image'"
                                [imgSrc]="imageUrl()">
                        </phx-drag-drop>
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Image Alt</mat-label>
                            <input matInput autocomplete="off" placeholder="Image Alt" formControlName="image_alt" />
                        </mat-form-field>
                    </div>



                    <div class="col-md-2">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Target</mat-label>
                            <mat-select formControlName="open_in">
                                <mat-option value="new_tab">Neuer Tab</mat-option>
                                <mat-option value="same_tab">Gleicher Tab</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="text-right">
                    <button class="btn-secondary" matStepperPrevious>Zurück</button>
                    <button class="btn-primary" matStepperNext>Weiter</button>
                </div>
            </form>
        </mat-step>

        <!-- ══ Step 3 – Recipients ═══════════════════════════════════════════ -->
        <mat-step>
            <form [formGroup]="popupFormGroup">
                <ng-template matStepLabel>Recipients</ng-template>

                <div class="row">

                        <mat-button-toggle-group [(value)]="recipientMode" class="col-md-auto mb-0">
                            <mat-button-toggle value="filter">DC / VIS / Region</mat-button-toggle>
                            <mat-button-toggle value="idf">IDF Liste hochladen</mat-button-toggle>
                        </mat-button-toggle-group>

                </div>

                @if (recipientMode() === 'filter') {
                    <div class="row mt-m">
                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Distribution Centers</mat-label>
                                <mat-select formControlName="distribution_centers" multiple>
                                    <mat-option value="dc1">DC 1</mat-option>
                                    <mat-option value="dc2">DC 2</mat-option>
                                    <mat-option value="dc3">DC 3</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>VIS Authority</mat-label>
                                <mat-select formControlName="vis_authorities" multiple>
                                    <mat-option value="vis1">VIS 1</mat-option>
                                    <mat-option value="vis2">VIS 2</mat-option>
                                    <mat-option value="vis3">VIS 3</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Region (DC)</mat-label>
                                <mat-select formControlName="regions" multiple>
                                    <mat-option value="region1">Region 1</mat-option>
                                    <mat-option value="region2">Region 2</mat-option>
                                    <mat-option value="region3">Region 3</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                }

                @if (recipientMode() === 'idf') {
                    <div class="row mt-m">
                        <div class="col-md-6">
<!--                            <label>IDF List (CSV/XLSX)</label>-->
<!--                            <input type="file" accept=".csv,.xlsx" (change)="onIdfListUpload($event)" />-->
<!--                            @if (idfListFile(); as file) {-->
<!--                                <small class="text-muted">Selected: {{ file.name }}</small>-->
<!--                            }-->
                            <phx-drag-drop
                                    (readFiles)="onIdfListUpload($event)"
                                    [invalid]="invalid"
                                    [acceptedFileTypes]="'csv'">
                            </phx-drag-drop>
                        </div>
                    </div>
                }

                <div class="text-right">
                    <button class="btn-secondary" matStepperPrevious>Zurück</button>
                    <button class="btn-primary" matStepperNext>Weiter</button>
                </div>
            </form>
        </mat-step>

        <!-- ══ Step 4 – Preview ══════════════════════════════════════════════ -->
        <mat-step>
            <ng-template matStepLabel>Preview</ng-template>

            <div class="preview-container"
                 style="border: 1px solid #ddd; padding: 24px; border-radius: 8px; max-width: 480px;">
                <h3>{{ popupFormGroup.get('title')?.value }}</h3>

                @if (imagePreview()) {
                    <img
                            [src]="imagePreview()"
                            [alt]="popupFormGroup.get('image_alt')?.value"
                            style="max-width: 100%; margin-bottom: 12px;"
                    />
                }

                <p>{{ popupFormGroup.get('body')?.value }}</p>

                @if (popupFormGroup.get('highlight')?.value) {
                    <p><strong>{{ popupFormGroup.get('highlight')?.value }}</strong></p>
                }

                @if (popupFormGroup.get('disclaimer')?.value) {
                    <p><small>{{ popupFormGroup.get('disclaimer')?.value }}</small></p>
                }

                @if (popupFormGroup.get('link')?.value) {
                    <a
                            [href]="popupFormGroup.get('link')?.value"
                            [target]="popupFormGroup.get('open_in')?.value === 'new_tab' ? '_blank' : '_self'"
                    >
                        {{ popupFormGroup.get('button')?.value || 'More info' }}
                    </a>
                }
            </div>

            <div class="text-right" style="margin-top: 16px;">
                <button class="btn-secondary" matStepperPrevious>Back</button>
                <button class="btn-primary" (click)="onSubmit()">Save</button>
            </div>
        </mat-step>

    </mat-vertical-stepper>
</mat-dialog-content>

<!--<mat-dialog-actions align="end">-->
<!--    <button class="btn-secondary mt-0" (click)="onCancel()">Abbrechen</button>-->
<!--    <button class="btn-primary mt-0" (click)="data.mode === 'edit' ? onEditAd() : onCreateAd()"-->
<!--            [disabled]="!isFormValid()">-->
<!--        {{ submitButtonText() }}-->
<!--    </button>-->
<!--</mat-dialog-actions>-->